

















import Vue from 'vue'
import TaskHeader from '@/pages/bank/common/parts/Header.vue'
import TaskContent from '@/pages/bank/lesson-tasks/create/parts/Content.vue'
import TaskFooter from '@/pages/bank/common/parts/Footer.vue'
import {
  save,
  $canSave,
  clearFields,
  setRedirectAfterSave,
  componentMounted,
  componentDestroyed,
} from '@/pages/bank/lesson-tasks/create/task-creation-page.model'
import { createLessonAssignmentFx } from '@/features/api/assignment/lesson-assignment/create-lesson-assignment'

export default Vue.extend({
  name: 'TaskCreationPage',
  components: {
    TaskHeader,
    TaskContent,
    TaskFooter,
  },
  effector: {
    $canSave,
    isLoading: createLessonAssignmentFx.pending,
  },
  methods: {
    saveTask(isRedirect: boolean) {
      save()
      if (isRedirect) setRedirectAfterSave(true)
    },
  },
  mounted() {
    componentMounted()
  },
  beforeDestroy() {
    componentDestroyed()
    clearFields()
  },
})
